import { createSlice } from "@reduxjs/toolkit";

export const paymentSlice = createSlice({
  name: "payment",
  initialState: {
    paymentData: {},
  },
  reducers: {
    setPaymentData: (state, action) => {
      state.paymentData = { ...state.paymentData, ...action.payload };
    },
  },
});

export const { setPaymentData } = paymentSlice.actions;

export const selectPaymentData = (state) => state.payment.paymentData;

export default paymentSlice.reducer;
